<div class="metadata-container">
  <div class="metadata-header">
    <label class="metadata-title">{{ "imagePropertyEdit.properties" | translate }}</label>
  </div>

  <div class="metadata-content">
    <table>
      <tr class="image-metadata" *ngFor="let property of properties">
        <td class="label">{{ property.key | translate }}</td>
        <td class="value">{{ property.value }}</td>
      </tr>
    </table>
  </div>

  <div class="metadata-header">
    <label class="metadata-title">{{ "imagePropertyEdit.metadataTitle" | translate }}</label>
  </div>

  <div class="metadata-content">
    <table *ngIf="imageMetadata && imageMetadata.metadata">
      <tr class="image-metadata" *ngFor="let entry of imageMetadata.metadata | keyvalue">
        <td class="label">{{ entry.key }}</td>
        <td class="value">{{ entry.value.value }}</td>
      </tr>
    </table>

    <table *ngIf="!imageMetadata || !imageMetadata.metadata">
      <tr>
        <td class="image-metadata no-metadata-label">{{ "imagePropertyEdit.noMetadata" | translate }}</td>
      </tr>
    </table>
  </div>
</div>
